<div class="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-6 gap-3">
    <div>
        <h2 class="text-xl font-semibold text-gray-900">Configuración del Carrusel</h2>
        <p class="text-sm text-gray-600 mt-1">
            Los banners que la app muestra en el inicio. Lo que publiques se ve en hasta 5 minutos.
        </p>
    </div>
    <div *ngIf="canEdit" class="flex space-x-2">
        <button type="button" (click)="openCreate('image')"
            class="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
            <i class="fas fa-image mr-2"></i>Agregar imagen
        </button>
        <button type="button" (click)="openCreate('icon')"
            class="bg-white hover:bg-gray-50 text-blue-700 border border-blue-600 px-4 py-2 rounded-lg font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
            <i class="fas fa-th-large mr-2"></i>Agregar tarjeta
        </button>
    </div>
</div>

<!-- Loading State -->
<div *ngIf="loading" class="text-center py-12">
    <i class="fas fa-spinner fa-spin text-4xl text-blue-600 mb-4"></i>
    <p class="text-gray-600">Cargando el carrusel...</p>
</div>

<!-- Global Status -->
<div *ngIf="!loading" class="bg-gray-50 rounded-lg border border-gray-200 p-6 mb-6">
    <div class="flex items-center justify-between">
        <div class="flex-1">
            <h3 class="text-lg font-semibold text-gray-900 mb-2">
                <i class="fas fa-power-off text-blue-600 mr-2"></i>
                Estado Global del Carrusel
            </h3>
            <p class="text-sm text-gray-600">
                Apagado, la app no muestra ningún banner aunque haya activos en la lista
            </p>
        </div>
        <div class="ml-6">
            <label class="relative inline-flex items-center cursor-pointer">
                <input type="checkbox" [checked]="enabled" (change)="onGlobalToggleChange($event)"
                    [disabled]="toggleLoading || !canEdit" class="sr-only peer" />
                <div
                    class="w-14 h-7 bg-gray-300 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[4px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-6 after:w-6 after:transition-all peer-checked:bg-blue-600">
                </div>
                <span class="ml-3 text-sm font-medium" [class.text-green-600]="enabled" [class.text-gray-500]="!enabled">
                    {{ enabled ? 'Activado' : 'Desactivado' }}
                </span>
            </label>
        </div>
    </div>
</div>

<!-- The app shows at most N per kind -->
<div *ngFor="let notice of capacityNotices" class="bg-amber-50 border-l-4 border-amber-400 p-3 mb-4">
    <p class="text-sm text-amber-800"><i class="fas fa-exclamation-triangle mr-2"></i>{{ notice }}</p>
</div>

<!-- Items -->
<div *ngIf="!loading && items.length > 0" class="space-y-4">
    <div class="flex items-center justify-between">
        <h3 class="text-lg font-semibold text-gray-900">Banners del carrusel</h3>
        <span class="text-xs text-gray-500">
            Activos: {{ activeByKind.image }} de imagen · {{ activeByKind.icon }} con ícono · la app muestra hasta {{ maxActivePerKind }} de cada tipo
        </span>
    </div>

    <div *ngFor="let item of items; let i = index; trackBy: trackById"
        class="bg-white rounded-lg border p-4 flex items-start gap-4"
        [ngClass]="item.legacy ? 'border-dashed border-gray-300 bg-gray-50' : 'border-gray-200'">

        <!-- Order controls -->
        <div class="flex flex-col items-center space-y-1 pt-1">
            <button type="button" (click)="move(i, -1)" [disabled]="!canEdit || reordering || !!busyId || !canMove(i, -1)"
                class="text-gray-400 hover:text-blue-600 focus:outline-none disabled:opacity-30 disabled:cursor-not-allowed"
                title="Subir">
                <i class="fas fa-chevron-up"></i>
            </button>
            <span class="bg-blue-100 text-blue-800 text-xs font-semibold px-2 py-0.5 rounded">{{ i + 1 }}</span>
            <button type="button" (click)="move(i, 1)" [disabled]="!canEdit || reordering || !!busyId || !canMove(i, 1)"
                class="text-gray-400 hover:text-blue-600 focus:outline-none disabled:opacity-30 disabled:cursor-not-allowed"
                title="Bajar">
                <i class="fas fa-chevron-down"></i>
            </button>
        </div>

        <!-- Artwork / icon -->
        <div class="flex-shrink-0">
            <img *ngIf="!item.legacy && item.kind === 'image' && item.image_url; else iconBadge" [src]="item.image_url"
                [alt]="item.alt_text || item.title" class="banner-thumb border border-gray-200 bg-gray-100" />
            <ng-template #iconBadge>
                <div class="banner-icon-badge" [class.banner-icon-badge--legacy]="item.legacy">
                    <i class="fas" [ngClass]="item.legacy ? 'fa-history' : iconClass(item.icon)"></i>
                </div>
            </ng-template>
        </div>

        <!-- Copy -->
        <div class="flex-1 min-w-0">
            <div class="flex flex-wrap items-center gap-2 mb-1">
                <span class="text-xs font-semibold px-2 py-0.5 rounded"
                    [ngClass]="item.legacy ? 'bg-gray-200 text-gray-700' : (item.kind === 'image' ? 'bg-purple-100 text-purple-800' : 'bg-blue-100 text-blue-800')">
                    {{ kindLabel(item) }}
                </span>
                <span *ngIf="!item.legacy && isExpired(item)" class="bg-red-100 text-red-800 text-xs font-semibold px-2 py-0.5 rounded">Vencido</span>
                <span *ngIf="!item.legacy && isScheduled(item)" class="bg-amber-100 text-amber-800 text-xs font-semibold px-2 py-0.5 rounded">Programado</span>
                <h4 class="text-base font-semibold text-gray-900 truncate">{{ item.title || '(sin nombre)' }}</h4>
            </div>
            <p *ngIf="item.description" class="text-sm text-gray-600 truncate">{{ item.description }}</p>
            <p *ngIf="!item.legacy && item.kind === 'image' && item.alt_text" class="text-xs text-gray-500 truncate">
                Texto alternativo: {{ item.alt_text }}
            </p>
            <div class="flex flex-wrap gap-x-4 gap-y-1 text-xs text-gray-500 mt-2">
                <span><i class="fas fa-hand-pointer mr-1"></i>{{ actionLabel(item) }}</span>
                <span *ngIf="!item.legacy"><i class="fas fa-calendar-alt mr-1"></i>{{ windowLabel(item) }}</span>
                <span *ngIf="!item.legacy && item.kind === 'icon' && item.cta_label"><i class="fas fa-square mr-1"></i>Botón: {{ item.cta_label }}</span>
                <span *ngIf="!item.legacy && item.kind === 'image' && imageMeta(item)"><i class="fas fa-expand mr-1"></i>{{ imageMeta(item) }}</span>
                <span *ngIf="!item.legacy && item.updated_at">
                    <i class="fas fa-user-edit mr-1"></i>{{ item.updated_at | date:'dd-MMM-yyyy HH:mm':undefined:'es' }}<ng-container *ngIf="item.updated_by"> · {{ item.updated_by }}</ng-container>
                </span>
            </div>
            <p *ngIf="item.legacy" class="text-xs text-gray-600 mt-2">
                <i class="fas fa-info-circle mr-1"></i>Lo creó la consola anterior para la app Ionic, que ya no existe. La app actual no lo muestra: elimínalo.
            </p>
        </div>

        <!-- Row actions -->
        <div class="flex items-center space-x-3 flex-shrink-0">
            <label *ngIf="!item.legacy" class="relative inline-flex items-center cursor-pointer" title="Activo en la app">
                <input type="checkbox" [checked]="item.status" (change)="onItemToggleChange(item, $event)"
                    [disabled]="!canEdit || busyId === item.id" class="sr-only peer" />
                <div
                    class="w-11 h-6 bg-gray-300 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600">
                </div>
            </label>
            <button *ngIf="!item.legacy" type="button" (click)="openEdit(item)" [disabled]="!canEdit || !!busyId"
                class="text-gray-500 hover:text-blue-600 focus:outline-none disabled:opacity-50" title="Editar">
                <i class="fas fa-pen"></i>
            </button>
            <button *ngIf="!item.legacy && item.kind === 'image'" type="button" (click)="openReplaceImage(item)"
                [disabled]="!canEdit || !!busyId"
                class="text-gray-500 hover:text-blue-600 focus:outline-none disabled:opacity-50" title="Reemplazar imagen">
                <i class="fas fa-sync-alt"></i>
            </button>
            <button type="button" (click)="remove(item)" [disabled]="!canEdit || !!busyId"
                class="text-red-500 hover:text-red-700 focus:outline-none disabled:opacity-50" title="Eliminar">
                <i class="fas" [class.fa-trash]="busyId !== item.id" [class.fa-spinner]="busyId === item.id"
                    [class.fa-spin]="busyId === item.id"></i>
            </button>
        </div>
    </div>
</div>

<!-- Empty State -->
<div *ngIf="!loading && items.length === 0"
    class="text-center py-12 bg-white rounded-lg border border-gray-200 border-dashed">
    <i class="fas fa-images text-6xl text-gray-300 mb-4"></i>
    <p class="text-gray-600 text-lg mb-2">No hay banners en el carrusel</p>
    <p class="text-gray-500 text-sm">Agrega una imagen o una tarjeta con ícono para mostrarla en el inicio de la app</p>
</div>

<!-- Viewer: the app's Home with every banner the customer sees right now, in the app's two rows -->
<div *ngIf="!loading" class="bg-white rounded-lg border border-gray-200 p-6 mt-6">
    <h3 class="text-lg font-semibold text-gray-900 mb-4">
        <i class="fas fa-eye text-blue-600 mr-2"></i>
        Así lo ve el cliente
    </h3>

    <div class="flex flex-col md:flex-row md:items-start md:space-x-8">
        <div class="app-phone flex-shrink-0 mx-auto md:mx-0">
            <div class="app-phone__home">
                <div class="h-4 w-24 bg-gray-200 rounded"></div>
                <div class="h-20 bg-gray-200 rounded-xl"></div>

                <ng-container *ngIf="!viewerEmpty">
                    <div *ngIf="liveImages.length > 0" class="app-phone__strip" [class.app-phone__strip--overflow]="liveImages.length > 1">
                        <div *ngFor="let item of liveImages; trackBy: trackById" class="app-phone__banner-image"
                            [style.width.px]="stripItemWidth(liveImages.length)">
                            <ng-container *ngTemplateOutlet="phoneImage; context: { $implicit: item.image_url, alt: item.alt_text || item.title }"></ng-container>
                        </div>
                    </div>
                    <div *ngIf="liveIcons.length > 0" class="app-phone__strip" [class.app-phone__strip--overflow]="liveIcons.length > 1">
                        <div *ngFor="let item of liveIcons; trackBy: trackById" class="app-phone__banner-card"
                            [style.width.px]="stripItemWidth(liveIcons.length)">
                            <ng-container *ngTemplateOutlet="phoneIconCard; context: { $implicit: cardOf(item) }"></ng-container>
                        </div>
                    </div>
                </ng-container>

                <div class="h-3 w-28 bg-gray-200 rounded"></div>
                <div class="h-14 bg-gray-200 rounded-xl"></div>
                <div class="h-14 bg-gray-200 rounded-xl"></div>
            </div>
        </div>

        <div class="mt-6 md:mt-0 flex-1 space-y-3">
            <div class="border-l-4 p-3" [ngClass]="viewerEmpty ? 'bg-gray-50 border-gray-400' : 'bg-blue-50 border-blue-400'">
                <p class="text-sm font-medium" [ngClass]="viewerEmpty ? 'text-gray-700' : 'text-blue-700'">
                    <i class="fas fa-mobile-alt mr-2"></i>{{ viewerStatus }}
                </p>
            </div>
            <ul *ngIf="viewerHints.length > 0" class="space-y-2">
                <li *ngFor="let hint of viewerHints" class="text-xs text-gray-600">
                    <i class="fas fa-info-circle text-blue-500 mr-1"></i>{{ hint }}
                </li>
            </ul>
            <p class="text-xs text-gray-500">Lo que ya está publicado tarda hasta 5 minutos en llegar a la app; este visor lo muestra al instante.</p>
        </div>
    </div>
</div>

<!-- Pieces of the phone mock, shared by the viewer and the editor -->
<ng-template #phoneImage let-src let-alt="alt">
    <img *ngIf="src; else noPhoneImage" [src]="src" [alt]="alt" />
    <ng-template #noPhoneImage>
        <div class="app-phone__placeholder">
            <i class="fas fa-image mb-1"></i>
            <span>Sin imagen</span>
        </div>
    </ng-template>
</ng-template>

<ng-template #phoneIconCard let-card>
    <span class="app-phone__banner-icon"><i class="fas" [ngClass]="iconClass(card.icon)"></i></span>
    <span class="app-phone__banner-copy">
        <span class="app-phone__banner-title" [class.app-phone__text--placeholder]="card.titlePlaceholder">{{ card.title }}</span>
        <span class="app-phone__banner-subtitle" [class.app-phone__text--placeholder]="card.subtitlePlaceholder">{{ card.subtitle }}</span>
    </span>
    <span *ngIf="card.cta" class="app-phone__banner-cta">{{ card.cta }}</span>
</ng-template>

<!-- Editor -->
<div *ngIf="editorOpen" class="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50" (click)="closeEditor()">
    <div class="relative top-10 mx-auto p-5 border w-full max-w-2xl shadow-lg rounded-md bg-white mb-10" (click)="$event.stopPropagation()">
        <div class="flex justify-between items-center mb-4">
            <h3 class="text-lg font-semibold text-gray-900">{{ editorTitle }}</h3>
            <button type="button" (click)="closeEditor()" [disabled]="saving" class="text-gray-400 hover:text-gray-600 focus:outline-none">
                <i class="fas fa-times"></i>
            </button>
        </div>

        <div class="space-y-5">
            <!-- Image: picker + preview -->
            <div *ngIf="showsImagePicker">
                <label for="carouselImageInput"
                    class="flex flex-col items-center justify-center w-full px-6 py-6 border-2 border-dashed rounded-lg transition-colors"
                    [ngClass]="!saving ? 'border-gray-300 hover:border-blue-400 cursor-pointer' : 'border-gray-200 bg-gray-50 cursor-not-allowed'">
                    <i class="fas fa-upload text-3xl text-gray-400 mb-3"></i>
                    <span class="text-sm font-medium text-gray-700">Elegir imagen</span>
                    <span class="text-xs text-gray-500 mt-1">PNG, JPG o WebP · apaisada 16:9 · ideal 1600 × 900 px · máximo 2 MB</span>
                    <input id="carouselImageInput" type="file" class="sr-only" [accept]="imageAccept" [disabled]="saving"
                        (change)="onFileSelected($event)" />
                </label>

                <div *ngIf="imageChecking" class="mt-3 text-sm text-gray-600">
                    <i class="fas fa-spinner fa-spin mr-2"></i>Revisando la imagen...
                </div>
                <div *ngIf="selectedImage && !imageChecking" class="mt-3 rounded-lg border px-4 py-3"
                    [ngClass]="selectedImageError ? 'border-red-200 bg-red-50' : 'border-green-200 bg-green-50'">
                    <div class="flex items-start justify-between">
                        <div class="min-w-0">
                            <p class="text-sm font-medium text-gray-900 truncate">{{ selectedImage.name }}</p>
                            <p class="text-xs text-gray-600 mt-0.5">
                                <span *ngIf="selectedImage.width !== null">{{ selectedImage.width }} × {{ selectedImage.height }} px · </span>{{ selectedImage.sizeKb }} KB · {{ selectedImage.format }}
                            </p>
                            <p *ngIf="selectedImageError" class="text-xs text-red-700 mt-1">
                                <i class="fas fa-exclamation-circle mr-1"></i>{{ selectedImageError }}
                            </p>
                        </div>
                        <div class="ml-4 flex items-center space-x-3 flex-shrink-0">
                            <span *ngIf="!selectedImageError" class="bg-green-100 text-green-800 text-xs font-semibold px-2.5 py-0.5 rounded">
                                <i class="fas fa-check mr-1"></i>Lista
                            </span>
                            <button type="button" (click)="clearSelectedFile()" [disabled]="saving"
                                class="text-gray-400 hover:text-gray-600 focus:outline-none disabled:opacity-50" title="Quitar archivo">
                                <i class="fas fa-times"></i>
                            </button>
                        </div>
                    </div>
                    <ul *ngIf="selectedImageWarnings.length > 0" class="mt-2 space-y-1">
                        <li *ngFor="let warning of selectedImageWarnings" class="text-xs text-amber-800">
                            <i class="fas fa-exclamation-triangle mr-1"></i>{{ warning }}
                        </li>
                    </ul>
                </div>
            </div>

            <!-- Copy -->
            <ng-container *ngIf="showsFields">
                <div *ngIf="draft.kind === 'icon'" class="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div class="md:col-span-2">
                        <label class="block text-sm font-medium text-gray-700 mb-1">Título <span class="text-red-500">*</span>
                            <span class="text-xs text-gray-500 font-normal">({{ draft.title.length }}/{{ titleMax }})</span>
                        </label>
                        <input type="text" [(ngModel)]="draft.title" [maxlength]="titleMax" [disabled]="saving"
                            placeholder="ej: Compra un seguro"
                            class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" />
                    </div>
                    <div class="md:col-span-2">
                        <label class="block text-sm font-medium text-gray-700 mb-1">Subtítulo <span class="text-red-500">*</span>
                            <span class="text-xs text-gray-500 font-normal">({{ draft.description.length }}/{{ limits.text.description }})</span>
                        </label>
                        <textarea [(ngModel)]="draft.description" [maxlength]="limits.text.description" rows="2" [disabled]="saving"
                            placeholder="ej: ¡Págalo ya! Y recibe el respaldo que necesitas."
                            class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"></textarea>
                    </div>
                    <div>
                        <label class="block text-sm font-medium text-gray-700 mb-1">Ícono <span class="text-red-500">*</span></label>
                        <select [(ngModel)]="draft.icon" [disabled]="saving"
                            class="w-full px-3 py-2 border border-gray-300 rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
                            <option *ngFor="let icon of icons" [value]="icon">{{ iconLabel(icon) }}</option>
                        </select>
                    </div>
                    <div>
                        <label class="block text-sm font-medium text-gray-700 mb-1">Texto del botón
                            <span class="text-xs text-gray-500 font-normal">({{ draft.ctaLabel.length }}/{{ limits.text.cta_label }})</span>
                        </label>
                        <input type="text" [(ngModel)]="draft.ctaLabel" [maxlength]="limits.text.cta_label" [disabled]="saving"
                            placeholder="ej: Ver"
                            class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" />
                        <p class="text-xs text-gray-500 mt-1">En la app solo el botón es tocable: una tarjeta con acción lo necesita</p>
                    </div>
                </div>

                <div *ngIf="draft.kind === 'image'" class="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                        <label class="block text-sm font-medium text-gray-700 mb-1">Nombre interno
                            <span class="text-xs text-gray-500 font-normal">({{ draft.title.length }}/{{ limits.text.image_name }})</span>
                        </label>
                        <input type="text" [(ngModel)]="draft.title" [maxlength]="limits.text.image_name" [disabled]="saving"
                            placeholder="ej: Promo octubre"
                            class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" />
                        <p class="text-xs text-gray-500 mt-1">Solo para esta lista; el cliente no lo ve</p>
                    </div>
                    <div>
                        <label class="block text-sm font-medium text-gray-700 mb-1">Texto alternativo
                            <span class="text-xs text-gray-500 font-normal">({{ draft.altText.length }}/{{ limits.text.alt_text }})</span>
                        </label>
                        <input type="text" [(ngModel)]="draft.altText" [maxlength]="limits.text.alt_text" [disabled]="saving"
                            placeholder="ej: Oferta de octubre en Casa Total"
                            class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" />
                        <p class="text-xs text-gray-500 mt-1">Lo lee el lector de pantalla del teléfono</p>
                    </div>
                </div>

                <!-- Tap action -->
                <div class="bg-gray-50 rounded-lg border border-gray-200 p-4">
                    <p class="text-sm font-semibold text-gray-900 mb-3"><i class="fas fa-link text-blue-600 mr-2"></i>Acción al tocar</p>
                    <div class="space-y-3">
                        <label class="flex items-start cursor-pointer">
                            <input type="radio" name="draftActionType" value="" [(ngModel)]="draft.actionType" [disabled]="saving"
                                class="mt-1 h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300" />
                            <span class="ml-3 text-sm text-gray-900">Sin acción (solo informativo)</span>
                        </label>
                        <label class="flex items-start cursor-pointer">
                            <input type="radio" name="draftActionType" value="internal" [(ngModel)]="draft.actionType" [disabled]="saving"
                                class="mt-1 h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300" />
                            <span class="ml-3 text-sm text-gray-900">Abrir una pantalla de la app</span>
                        </label>
                        <div *ngIf="draft.actionType === 'internal'" class="ml-7">
                            <select [(ngModel)]="draft.internalRoute" [disabled]="saving"
                                class="w-full max-w-md px-3 py-2 border border-gray-300 rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
                                <option value="" disabled>Elige una pantalla</option>
                                <option *ngFor="let route of internalRoutes" [value]="route.value">{{ route.label }}</option>
                            </select>
                        </div>
                        <label class="flex items-start cursor-pointer">
                            <input type="radio" name="draftActionType" value="external" [(ngModel)]="draft.actionType" [disabled]="saving"
                                class="mt-1 h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300" />
                            <span class="ml-3 text-sm text-gray-900">Abrir un enlace externo</span>
                        </label>
                        <div *ngIf="draft.actionType === 'external'" class="ml-7">
                            <input type="url" [(ngModel)]="draft.externalUrl" placeholder="https://..." [disabled]="saving"
                                class="w-full max-w-md px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" />
                        </div>
                        <p class="text-xs text-blue-700 ml-7"><i class="fas fa-hand-pointer mr-1"></i>{{ draftTapHint }}</p>
                    </div>
                </div>

                <!-- Validity window + status -->
                <div class="grid grid-cols-1 md:grid-cols-3 gap-4 items-end">
                    <div>
                        <label class="block text-sm font-medium text-gray-700 mb-1">Mostrar desde</label>
                        <input type="date" [(ngModel)]="draft.startsOn" [disabled]="saving"
                            class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" />
                    </div>
                    <div>
                        <label class="block text-sm font-medium text-gray-700 mb-1">Mostrar hasta</label>
                        <input type="date" [(ngModel)]="draft.endsOn" [disabled]="saving"
                            class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" />
                    </div>
                    <label class="flex items-center cursor-pointer pb-2">
                        <input type="checkbox" [(ngModel)]="draft.status" [disabled]="saving"
                            class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" />
                        <span class="ml-2 text-sm text-gray-900">Activo en la app</span>
                    </label>
                </div>
                <p class="text-xs text-gray-500">Fechas en hora de Venezuela; vacías, el banner no tiene límite. Vencido o programado, el banner no se muestra aunque esté activo.</p>
            </ng-container>

            <!-- Preview: the app's Home with this banner in the carousel slot, live while the operator types -->
            <div class="bg-gray-50 rounded-lg border border-gray-200 p-4">
                <p class="text-sm font-semibold text-gray-900 mb-3"><i class="fas fa-eye text-blue-600 mr-2"></i>Así la verá el cliente</p>
                <div class="flex flex-col md:flex-row md:items-start md:space-x-6">
                    <div class="app-phone flex-shrink-0 mx-auto md:mx-0">
                        <div class="app-phone__home">
                            <div class="h-4 w-24 bg-gray-200 rounded"></div>
                            <div class="h-20 bg-gray-200 rounded-xl"></div>

                            <div *ngIf="draft.kind === 'image'" class="app-phone__banner-image">
                                <ng-container *ngTemplateOutlet="phoneImage; context: { $implicit: previewImage, alt: 'Vista previa del banner' }"></ng-container>
                            </div>

                            <div *ngIf="draft.kind === 'icon'" class="app-phone__banner-card">
                                <ng-container *ngTemplateOutlet="phoneIconCard; context: { $implicit: draftCard }"></ng-container>
                            </div>

                            <div class="h-3 w-28 bg-gray-200 rounded"></div>
                            <div class="h-14 bg-gray-200 rounded-xl"></div>
                            <div class="h-14 bg-gray-200 rounded-xl"></div>
                        </div>
                    </div>

                    <ul class="mt-4 md:mt-0 flex-1 space-y-2">
                        <li *ngFor="let hint of previewHints" class="text-xs text-gray-600">
                            <i class="fas fa-info-circle text-blue-500 mr-1"></i>{{ hint }}
                        </li>
                    </ul>
                </div>
            </div>

            <p *ngIf="draftError" class="text-xs text-red-700"><i class="fas fa-exclamation-circle mr-1"></i>{{ draftError }}</p>
        </div>

        <div class="flex justify-end space-x-3 mt-6">
            <button type="button" (click)="closeEditor()" [disabled]="saving"
                class="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-400 disabled:opacity-50">
                Cancelar
            </button>
            <button type="button" (click)="submit()" [disabled]="!canSubmit"
                class="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed">
                <i class="fas mr-2" [class.fa-spinner]="saving" [class.fa-spin]="saving" [class.fa-check]="!saving"></i>
                {{ saving ? 'Publicando...' : 'Confirmar y publicar' }}
            </button>
        </div>
    </div>
</div>
